// extracted by mini-css-extract-plugin
export var root = "_104-0";
export var scroll = "_104-1";
export var thumb = "_104-3";
export var track = "_104-2";